import ReactGA from 'react-ga';

let DEBUG = false;
let INITIALIZED = false;

function format(any) {
  return any instanceof Array ? any.join("|") : any;
}

function formatAll(obj) {
  for (var i in obj) {obj[i] = format(obj[i]);}
  return obj;
}

function initialize(gtag, debug) {
  DEBUG = debug;
  INITIALIZED = !!gtag;

  if (INITIALIZED) {
    ReactGA.initialize(gtag, { debug: DEBUG });
    ReactGA.pageview("/");
  }
}

function event(category, action, label) {
  const obj = formatAll({category, action, label});
  
  if (INITIALIZED) {ReactGA.event(obj);}
  if (DEBUG) {console.log("Analytics:", obj);}
}

function viewTake(label, real) {
  if (real !== false) {event("Section", "View", label);}
}

function fieldOpen(form, field) {
  event("Form", "Focus", [form, field]);
}

function fieldChange(form, field) {
  event("Form", "Change", [form, field]);
}

function formSubmit(form) {
  event("Form", "Submit", form);
}

function msgShow(level, type) {
  event("Modal", "Msg", [level, type]);
}

function linkClick(label) {
  event("Link", "Click", label);
}

export default initialize;
export {
  initialize,
  viewTake,
  fieldOpen,
  fieldChange,
  msgShow,
  formSubmit,
  linkClick,
}